<template>
  <div class="w-100 pt-5">
    <h4 class="text-akademica px-3 mb-5"><b>SEJA PROFESSOR</b></h4>

    <div class="row px-5">
      <div class="col-12 col-md-4 text-center">
        <p class="text-center text-akademica mb-3">
          <img height="80" src="../../assets/img/home/conteudo.png">
        </p>
        <h5 class="text-akademica">CONTEÚDO</h5>
        <h6 class="text-light text-dark">Compartilhe com outras pessoas o que você sabe de melhor.</h6>
      </div>

      <div class="col-12 col-md-4 text-center">
        <p class="text-center text-akademica mb-3">
          <img height="80" src="../../assets/img/home/facilidade.png">
        </p>
        <h5 class="text-akademica">FACILIDADE</h5>
        <h6 class="text-light text-dark">Ambiente prático para disponibilizar seu curso e suporte especializado.</h6>
      </div>

      <div class="col-12 col-md-4 text-center">
        <p class="text-center text-akademica mb-3">
          <img height="80" src="../../assets/img/home/renda_extra.png">
        </p>
        <h5 class="text-akademica">RENDA EXTRA</h5>
        <h6 class="text-light text-dark">Transforme seu talento em dinheiro, trabalhando exclusivamente de casa.</h6>
      </div>
    </div>

    <div class="w-100 home-img-text-item px-5 py-3 pt-5 mt-5 row text-center m-0">
      <div class="col-md-5 d-none d-md-flex justify-content-xl-center align-items-center">
        <img height="200" src="../../assets/img/home/seja_prof.png">
      </div>
      <div class="col p-0 d-flex justify-content-center justify-content-md-start align-items-center">
        <div>
          <h5><b>Seja um profissional do futuro e mostre seu contéudo na internet.</b></h5>
          <h6 class="text-light text-dark">«Sempre gostei de dar aula e com essa plataforma estou conseguindo fazer o que mais amo que é ensinar » Marcio Guidoni</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
